import woodsContractTemplate from '@/views/person-center/project/contract-comp/woods-contract-template/woods-contract-template.vue';
import ProjectService from '@/views/person-center/project/project.service.js';
import Service from '@/service/index.js';
import { successMessage, errorMessage } from '@/utils/message.js';
const debounce = require('lodash.debounce');

export default {
  components: {
    woodsContractTemplate
  },
  props: {
    fromDate: {
      type: Object,
      default: {}
    }
  },
  data () {
    var oninput = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('提示请输入1-1000的整数'));
      } else if (value <= 0 || value > 1000) {
        callback(new Error('请输入1-1000'));
      } else {
        callback();
      }
    };
    // var disposalRetained = (rule, value, callback) => {
    //   value.forEach((item, index) => {
    //     if(item.forestStatus === false) {
    //       callback(new Error('请输入留置林木的处置方式'));
    //     } else if(index === 0 && item.forestStatus === true && item.forestYear === '') {
    //       callback(new Error('请输入与有权收回该流转林权的权利人协商展期'));
    //     } else {
    //       callback();
    //     }
    //   });
    // };
    var disposalRetained = (rule, value, callback) => {
      let count = 0;
      value.forEach((item, index) => {
        if (item.forestStatus === false) {
          count++;
        }
        if (index === 0 && item.forestStatus === true && item.forestYear === '') {
          callback(new Error('请输入与有权收回该流转林权的权利人协商展期'));
        }
        if (index === 3 && item.forestStatus === true && item.forestRemark === '') {
          callback(new Error('请输入其他内容'));
        }
      });
      // 如果全部未选择
      if (count === 4) {
        callback(new Error('请输入留置林木的处置方式'));
      } else {
        callback();
      }
    };
    var disposalAncillary = (rule, value, callback) => {
      let count = 0;
      value.forEach((item, index) => {
        if (item.facilitiesStatus === false) {
          count++;
        }
        // 如果选择其他，输入框则必填
        if (index === 2 && item.facilitiesStatus === true && item.facilitiesRemark === '') {
          callback(new Error('请输入其他内容'));
        }
      });
      // 如果全部未选择
      if (count === 3) {
        callback(new Error('请输入附属设施处置方式'));
      } else {
        callback();
      }
    };
    const installmentSumTermValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入分期付款的期数'));
      } else if (value <= 0 || value > 100) {
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const installmentPerYearValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入每期多少年'));
      } else if (value <= 0 || value > 10) {
        return callback(new Error('1-10'));
      } else {
        callback();
      }
    };
    const afterYearsPayNextPriceValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入'));
      } else if (value <= 0 || value > 10) {
        return callback(new Error('1-10'));
      } else if (!this.ruleForm.afterDatePayNextPrice) {
        return callback(new Error('请选择日期'));
      } else {
        callback();
      }
    };
    const installmentPerYearPriceAddPercentValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入每期承包费递增百分比'));
      } else if (value < 0 || value > 100) {
        return callback(new Error('0-100'));
      } else {
        callback();
      }
    };
    const contractDepositValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入合同定金'));
      } else if (value < 0 || value > 999999999) {
        return callback(new Error('请输入0~999999999之间的整数'));
      } else {
        callback();
      }
    };
    const paymentContractDepositAgreedDayValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入支付合同定金约定日'));
      } else if (value < 0 || value > 999999999) {
        return callback(new Error('请输入0~999999999之间的整数'));
      } else {
        callback();
      }
    };
    const refundContractDepositAgreedDayValidator = (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入返还合同定金约定日'));
      } else if (value < 0 || value > 999999999) {
        return callback(new Error('请输入0~999999999之间的整数'));
      } else {
        callback();
      }
    };
    return {
      // 设置只能选择当前日期及之后的日期
      pickerOptions0: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      pickerOptions: {
        disabledDate (time) {
          const year = new Date().getFullYear();
          const showTime = time.getTime();
          const lastYear = `${year - 1}-12-31`;
          const nowYear = `${year}-12-31`;
          const twoMonth = `${year}-2-29`;
          const dayNum = new Date(year, 2, 0).getDate();
          if (dayNum === 29) {
            return (showTime <= new Date(lastYear).getTime()) || (showTime > new Date(nowYear).getTime()) || (showTime === new Date(twoMonth).getTime());
          } else {
            return (showTime <= new Date(lastYear).getTime()) || (showTime > new Date(nowYear).getTime());
          }
        }
      },
      checked: true,
      checked1: false,
      rateText: '林地林木成交价',
      areaText: '林地林木面积',
      ruleForm: {
        projectType: '',
        assetStatusDescription: '', // 资产情况现状描述
        circulationDisposalMethodDescription: '', // 流转处置方式描述
        lastDeliverDate: '', // 最晚交付日期
        sumCurrentPrice: '', // 林地木地成交价
        sumCurrentArea: '', // 总面
        remainingPriceOfFirstInstallment: '',
        contractEffectivePeriod: '',
        // paymentCirculationPriceCycle: '', // 支付流转价款周期
        // paymentTransferPriceDate: '', // 支付流转价款日期
        annualTurnoverPrice: '', // 每年流转价款
        remainMoney: '', // 剩余价款
        installmentSumTerm: '1',
        lastPayDate: '', // 剩余价款最晚支付日期
        inKindOrOtherMethod: '', // 以实物或者实物折资方式
        otherMethod: '', // 其他方式
        compensationFundsOtherDescription: '', // 补偿资金其他描述
        projectDeposit: '', // 项目定金
        contractDeposit: '', // 合同定金
        installmentPerYear: '', // 每期多少年
        installmentPriceOfFirst: '', // 第一期价款金额
        paymentContractDepositAgreedDay: '', // 支付合同定金约定
        refundContractDepositAgreedDay: '', // 返还合同定金约定
        accordingToLawInvest: '',
        againsCirculateForest: '',
        forestPropertyFinancingGuarantee: '',
        compensationAgreement: '', // 补偿费约定
        otherAgreedMatters: '',
        returningCirculatedAgreedDay: '', // 交还流转约定日
        partyaOverdueProportion: '', // 甲方逾期违约金比例
        partyaOverdueDate: '', // 乙方逾期违约金比例
        partybOverdueProportion: '', // 乙方逾期违约金比例
        partybOverdueDate: '', // 乙方逾期超时日
        afforestationGreeningExpireDay: '', // 造林绿化约定期满日
        resolveDisputesWays: '', // 解决争议途径
        additionalTerms: '', // 补充条款
        needContractMainName: '', // 需要合同的主体名称
        compensationFundsOwnership: '', // 补偿资金归属
        afterYearsPayNextPrice: '', // 以后每
        afterDatePayNextPrice: '', // 月日
        installmentPerYearPriceAddPercent: '', // 每期林地流转价款递增
        taxTreatmentMethod: '', // 税费处理方式
        payType: '',
        installmentPriceOfFirstExList: [
          {
            amount: '',
            payDate: ''
          }
        ],
        disposalRetainedForest: [
          {
            forestStatus: false,
            forestRemarkStatus: false,
            forestYear: '',
            forestRemark: ''
          },
          {
            forestStatus: false,
            forestRemarkStatus: false,
            forestYear: '',
            forestRemark: ''
          },
          {
            forestStatus: false,
            forestRemarkStatus: false,
            forestYear: '',
            forestRemark: ''
          },
          {
            forestStatus: false,
            forestRemarkStatus: false,
            forestYear: '',
            forestRemark: ''
          }
        ],
        disposalAncillaryFacilities: [
          {
            facilitiesStatus: false,
            facilitiesRemarkStatus: false,
            facilitiesRemark: ''
          },
          {
            facilitiesStatus: false,
            facilitiesRemarkStatus: false,
            facilitiesRemark: ''
          },
          {
            facilitiesStatus: false,
            facilitiesRemarkStatus: false,
            facilitiesRemark: ''
          }
        ]
      },
      compensateList: [
        { code: 1, 'value': '转让方（甲方)' },
        { code: 2, 'value': '受让方（乙方）' }
      ],
      projectDepositList: [
        { code: 1, 'value': '需要定金' },
        { code: 2, 'value': '不需要定金' }
      ],
      accordingToLawInvestList: [
        { code: 1, 'value': '转让方（甲方）同意' },
        { code: 2, 'value': '转让方（甲方）不同意' }
      ],
      againsCirculateForestList: [
        { code: 1, 'value': '转让方（甲方）同意' },
        { code: 2, 'value': '转让方（甲方）不同意' }
      ],
      forestPropertyFinancingGuaranteeList: [
        { code: 1, 'value': '转让方（甲方）同意' },
        { code: 2, 'value': '转让方（甲方）不同意' }
      ],
      rules: {
        assetStatusDescription: [
          { required: true, message: '请输入资产情况现状描述', trigger: 'blur' }
        ],
        circulationDisposalMethodDescription: [
          { required: true, message: '请输入流转处置方式描述', trigger: 'blur' }
        ],
        lastDeliverDate: [
          { required: true, message: '请选择最晚交付日期', trigger: 'blur' }
        ],
        contractEffectivePeriod: [
          { required: true, message: '请输入合同生效后多少天支付第一期剩余价款', trigger: 'blur' }
        ],
        // paymentCirculationPriceCycle: [
        //   { required: true, message: '请输入支付流转价款周期', trigger: 'blur' }
        // ],
        taxTreatmentMethod: [
          { required: true, message: '请输入税费处理方式', trigger: 'blur' }
        ],
        annualTurnoverPrice: [
          { required: true, message: '请输入每年流转价款', trigger: 'blur' }
        ],
        lastPayDate: [
          { required: true, message: '请选择剩余价款最晚支付日期', trigger: 'blur' }
        ],
        inKindOrOtherMethod: [
          { required: true, message: '请输入以实物或者实物折资方式', trigger: 'blur' }
        ],
        installmentSumTerm: [
          { required: true, validator: installmentSumTermValidator, trigger: 'blur' }
        ],
        installmentPerYear: [
          { required: true, validator: installmentPerYearValidator, trigger: 'blur' }
        ],
        afterYearsPayNextPrice: [
          { required: true, validator: afterYearsPayNextPriceValidator, trigger: 'change' }
        ],
        installmentPerYearPriceAddPercent: [
          { required: true, validator: installmentPerYearPriceAddPercentValidator, trigger: 'blur' }
        ],
        projectDeposit: [
          { required: true, message: '请选择是否需要定金', trigger: 'change' }
        ],
        compensationFundsOwnership: [
          { required: true, message: '请选择补偿资金归属', trigger: 'change' }
        ],
        contractDeposit: [
          { required: true, validator: contractDepositValidator, trigger: 'blur' }
        ],
        paymentContractDepositAgreedDay: [
          { required: true, validator: paymentContractDepositAgreedDayValidator, trigger: 'blur' }
        ],
        refundContractDepositAgreedDay: [
          { required: true, validator: refundContractDepositAgreedDayValidator, trigger: 'blur' }
        ],
        accordingToLawInvest: [
          { required: true, message: '请选择依法投资改良土壤', trigger: 'change' }
        ],
        againsCirculateForest: [
          { required: true, message: '请选择再次流转林权', trigger: 'change' }
        ],
        forestPropertyFinancingGuarantee: [
          { required: true, message: '请选择林权融资担保', trigger: 'change' }
        ],
        compensationAgreement: [
          { required: true, message: '请输入补偿费约定', trigger: 'blur' }
        ],
        returningCirculatedAgreedDay: [
          { required: true, message: '请输入交还流转预定日', trigger: 'blur' }
        ],
        partyaOverdueProportion: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        partyaOverdueDate: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        partybOverdueProportion: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        partybOverdueDate: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        afforestationGreeningExpireDay: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        resolveDisputesWays: [
          { required: true, message: '请选择解决争议途径', trigger: 'blur' }
        ],
        disposalRetainedForest: [
          { required: true, validator: disposalRetained, trigger: 'blur' }
        ],
        disposalAncillaryFacilities: [
          { required: true, validator: disposalAncillary, trigger: 'blur' }
        ]
      },
      dialogFormVisible: false,
      disputeWay: null, // 争议解决途径
      contractPeriod: null, // 承包期限
      previewContract: null, // 预览合同的信息
      citytitle: '',
      massifType: null // 地块类型
    };
  },
  created () {
    this.ruleForm.userId = this.fromDate && this.fromDate.userId;
    this.ruleForm.projectId = this.fromDate && this.fromDate.id;
    this.ruleForm.projectType = this.fromDate && this.fromDate.projectType;
    this.ruleForm.projectSubType = this.fromDate && this.fromDate.projectSubType;
    if (Number(this.ruleForm.projectSubType) === 2) {
      this.rateText = '林地成交价';
      this.areaText = '林地面积';
    } else if (Number(this.ruleForm.projectSubType) === 3) {
      this.rateText = '林木成交价';
    } else {
      this.rateText = '林地林木成交价';
      this.areaText = '林地林木面积';
    }
    this.getDictList();
  },
  watch: {
    'ruleForm.installmentPriceOfFirst' (newName, oldName) {
      if (newName !== oldName) {
        this.ruleForm.remainingPriceOfFirstInstallment = this.ruleForm.installmentPriceOfFirst - (this.createContractInfo.marginSubServiceFee);
      }
    },
    'ruleForm.projectDeposit' (value, oldValue) {
      if (Number(value) === 2 || Number(oldValue) === 2) {
        this.ruleForm = {
          ...this.ruleForm,
          contractDeposit: '',
          paymentContractDepositAgreedDay: '',
          refundContractDepositAgreedDay: ''
        };
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs['signUpForm'].resetFields();
    });
    this.getContractData();
  },
  methods: {
    installmentPriceOfFirstValidator (rule, value, callback) {
      if (value === '') {
        return callback(new Error('请输入价款金额'));
      } else if (Number(value) < (this.createContractInfo && this.createContractInfo.marginSubServiceFee)) {
        return callback(new Error('不能小于竞价保证金-服务费'));
      } else {
        callback();
      }
    },
    payDateValidator (rule, value, callback) {
      if (value === '') {
        return callback(new Error('请选择最晚支付日期'));
      } else {
        callback();
      }
    },
    // 验证分期金额是否等于总金额
    validateSumPrice () {
      // 林木并且是分期支付
      if (Number(this.ruleForm.projectSubType) === 3 && Number(this.ruleForm.payType) === 2) {
        let sumNum = Number(this.ruleForm.installmentPriceOfFirst);
        this.ruleForm.installmentPriceOfFirstExList.map(item => {
          sumNum += Number(item.amount);
        });
        // 分期总金额 等于成交总金额
        if (sumNum === Number(this.ruleForm.sumCurrentPrice)) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    // 支付方式切换
    // paytypeClick() {
    //   this.ruleForm.paytype = !this.ruleForm.paytype;
    // },
    // 添加或者删除的时候
    handleChange (type) {
      console.log(this.ruleForm.installmentSumTerm, 'event');
      if (type === 1) {
        this.ruleForm.installmentSumTerm--;
        if (this.ruleForm.installmentSumTerm < 2) {
          this.ruleForm.installmentSumTerm = 2;
          return;
        }
        // 删除最后一个对象
        this.ruleForm.installmentPriceOfFirstExList.pop();
      } else {
        this.ruleForm.installmentSumTerm++;
        if (this.ruleForm.installmentSumTerm > 10) {
          this.ruleForm.installmentSumTerm = 10;
          return;
        }
        // 在最后面追加
        this.ruleForm.installmentPriceOfFirstExList.push({
          amount: '',
          payDate: ''
        });
      }
    },
    change () {
      this.$forceUpdate();
    },
    // 获取用户类型 字典查询
    getDictList () {
      const obj = {
        WOODLAND_DISPUTE_RESOLUTION_WAY: 'disputeWay',
        CONTRACT_PERIOD: 'contractPeriod',
        MASSIF_TYPE: 'massifType'
      };
      Object.keys(obj).forEach((key) => {
        Service.getSelectList(key).then(res => {
          if (res && res.code === '0') {
            this[obj[key]] = res.data;
          }
        });
      });
    },
    // 数据回显
    getContractData () {
      ProjectService.toCreateContract(this.ruleForm.projectId, this.ruleForm.userId, this.ruleForm.projectType).then(res => {
        if (res && res.code === '0') {
          this.createContractInfo = {
            ...res.data,
            disposalRetainedForest: JSON.parse(res.data.disposalRetainedForest),
            disposalAncillaryFacilities: JSON.parse(res.data.disposalAncillaryFacilities)
          };
          // 第一期价款金额如果小于0 则等于0
          if (res.data.installmentPriceOfFirst < 0) {
            this.createContractInfo.installmentPriceOfFirst = 0;
          }
          for (let key in this.createContractInfo) {
            if (key === 'disposalRetainedForest' && !this.createContractInfo.disposalRetainedForest) {
              this.ruleForm.disposalRetainedForest = this.ruleForm.disposalRetainedForest;
            } else if (key === 'disposalAncillaryFacilities' && !this.createContractInfo.disposalAncillaryFacilities) {
              this.ruleForm.disposalAncillaryFacilities = this.ruleForm.disposalAncillaryFacilities;
            } else if (key === 'annualTurnoverPrice') {
              if (this.createContractInfo.sumCurrentPrice > 0 && this.createContractInfo.sumCurrentArea > 0 && Number(this.createContractInfo.deliveryPeriod) > 0) {
                this.ruleForm.annualTurnoverPrice = (this.createContractInfo.sumCurrentPrice / this.createContractInfo.sumCurrentArea / this.createContractInfo.deliveryPeriod).toFixed(2);
              } else {
                this.ruleForm.annualTurnoverPrice = 0;
              }
            } else if (key === 'installmentSumTerm' && !this.createContractInfo.installmentSumTerm) {
              // 林木并且是分期支付
              if (Number(this.ruleForm.projectSubType) === 3 && this.createContractInfo.payType === 2) {
                this.ruleForm.installmentSumTerm = 2; // 至少两期
              }
            } else if (key === 'installmentPriceOfFirstExList' && !this.createContractInfo.installmentPriceOfFirstExList) {
            } else if (key === 'resolveDisputesWays' && res.data.resolveDisputesWays) {
              this.ruleForm.resolveDisputesWays = String(res.data.resolveDisputesWays);
              this.checked1 = true;
            } else {
              this.ruleForm[key] = this.createContractInfo[key];
            }
          }
        }
      });
    },
    previousStep () {
      this.$router.back();
    },
    // 预览合同 先提交再预览
    previewBtn: debounce(function () {
      if (this.validateSumPrice()) {
        errorMessage('分期金额之和必须等于林木成交价金额，请确认');
        return;
      }
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = true;
          this.submit(false);
        } else {
          return false;
        }
      });
    }),
    // 立即提交
    test: debounce(function () {
      if (this.validateSumPrice()) {
        errorMessage('分期金额之和必须等于林木成交价金额，请确认');
        return;
      }
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交合同信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit(true);
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    }),
    // 确认提交按钮
    submit (isSave) {
      // 保存接口传参
      ProjectService.createContract({
        isSave: isSave,
        ...this.ruleForm
      }).then(res => {
        if (isSave) {
          if (res && res.code === '0') {
            successMessage('创建成功');
            this.$router.push('/person-center/project/roll-out-project/list');
          } else if (res && res.reason) {
            errorMessage(res && res.reason);
          } else {
            errorMessage('创建失败');
          }
        } else {
          ProjectService.displayWoodsContract(
            this.ruleForm.projectId,
            this.ruleForm.projectType,
            this.ruleForm.userId,
            '1'
          ).then(res => {
            if (res && res.code === '0') {
              this.previewContract = res.data;
              // this.getContractData();
            }
          });
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('创建失败');
        }
      });
    }
  }
};
